import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf0ab0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Filtro de Notas", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " Refine sua pesquisa por notas abaixo", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limpar", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Aplicar", -1))

import { ref, onMounted, computed, withDefaults } from 'vue';
import { AtomSelect, AtomButton, AtomInput } from '@/components/atoms';
import { MoleculeCard } from '.'
import { Brand } from '@/core/model';
import { getPaginate } from '@/core/service/BrandsService'
import { IOptionsSelect } from '@/types';
import Swal from 'sweetalert2';

type Source = "resale" | "brand" | "warehouse" | "trigger" | "user" | "season";

interface PageData {
  source: Source
  page: number,
  enableToLoad: boolean
}

interface IProps {
  hasClient: boolean;
  hasResale: boolean;
  hasBrand: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeGradesFilter',
  props: {
    hasClient: { type: Boolean, default: true },
    hasResale: { type: Boolean, default: true },
    hasBrand: { type: Boolean, default: true }
  },
  emits: ["handleFilter", "handleClear"],
  setup(__props: any, { emit: __emit }) {

// import { defineProps } from 'vue';
const brands = ref<Brand[]>([]);
const filters = ref<any>({});
const props = __props;
const pagination = ref<PageData[]>([
  {
    source: 'brand',
    page: 1,
    enableToLoad: true
  }
]);
const emit = __emit
const brandsComputed = computed(() => {
  return brands.value?.map(x => {
    return { text: x.name, value: x.id } as IOptionsSelect
  })
})
function loadBrands() {
  const brands_page = pagination.value.find((p) => p.source === "brand");
  getPaginate(brands_page?.page ?? 1)
    .then((resp) => {
      if (brands_page) brands_page.enableToLoad = resp.data.length ?? false;

      brands.value?.push(...resp.data ?? []);
    });
}

function nextPagination(source: Source, cb: any) {
  const index = pagination.value.findIndex((p) => p.source === source);

  pagination.value[index].page++;

  cb();
}

function handleFilter() {
  const filter = JSON.parse(JSON.stringify(filters.value));
  if (filter.brand_id)
    filter.brand_id = filter.brand_id.join(',')

  if (!filter.start_date && filter.end_date) {
    Swal.fire({
      icon: "warning",
      title: "Atenção",
      text: "Selecione Data de De e de até!"
    })
    return
  }


  if (filter.start_date && !filter.end_date) {
    Swal.fire({
      icon: "warning",
      title: "Atenção",
      text: "Selecione Data de De e de até!"
    })
    return
  }

  emit("handleFilter", filter);
}
onMounted(() => {
  loadBrands();
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), { class: "width-card w-100" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pb-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pt-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    label: "Número da nota:",
                    placeholder: "Nota..",
                    modelValue: filters.value.invoice,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.invoice) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (props.hasClient)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomInput), {
                        label: "Nome do Cliente:",
                        placeholder: "Cliente..",
                        modelValue: filters.value.client,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.client) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.hasResale)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomInput), {
                        label: "Nome da Revenda:",
                        placeholder: "Revenda...",
                        modelValue: filters.value.reseale,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.reseale) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.hasBrand)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 2,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomSelect), {
                        multiple: true,
                        options: brandsComputed.value,
                        label: "Marca:",
                        placeholder: "Marca...",
                        enableLoad: pagination.value.find((p) => p.source === 'brand')?.enableToLoad ?? false,
                        onLoad: () => { nextPagination('brand', loadBrands) },
                        modelValue: filters.value.brand_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.brand_id) = $event))
                      }, null, 8, ["options", "enableLoad", "onLoad", "modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    label: "De:",
                    placeholder: "De...",
                    modelValue: filters.value.start_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.start_date) = $event)),
                    type: "date"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    label: "Até:",
                    placeholder: "Até...",
                    modelValue: filters.value.end_date,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.end_date) = $event)),
                    type: "date"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "my-3" }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    class: "btn-border text-bold w-100 text-sm pa-1 my-1",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {filters.value = {}; emit('handleClear', undefined);})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    class: "text-bold w-100 text-sm pa-1 my-1 btn-submit",
                    onClick: handleFilter
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})